﻿define('instrumentation/performance-api', ['lib/underscore'], function (_) {
    var windowPerformance = window.performance || {},
        performanceTiming = windowPerformance.timing || {},
        origin = performanceTiming.navigationStart || Date.now(),
        perfApi = {};

    addPerformanceApi(
        'mark',
        'clearMarks',
        'measure',
        'clearMeasures', {
            name: 'now',
            fallback: function () {
                return Date.now() - origin;
            },
        }, {
            name: 'setResourceTimingBufferSize',
            alias: 'setBufferSize',
        });

    return perfApi;

    function addPerformanceApi(/*apis*/) {
        var api, 
            apiName,
            apiAlias,
            apiFallback,
            apiFunction;

        for (var i = 0; i < arguments.length; ++i) {
            api = arguments[i];
            if (_.isString(api)) {
                api = { name: api };
            }

            apiName = api.name;
            apiAlias = api.alias || apiName;
            apiFallback = api.fallback || _.noop;

            apiFunction = _.bind(windowPerformance[apiName] || apiFallback, windowPerformance);

            perfApi[apiAlias] = apiFunction;
        }
    }
});
